var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-selector" },
    [
      _c(
        "div",
        { staticClass: "item-wrapper" },
        [
          _c("span", { staticClass: "label" }, [
            _vm._v("Whatsapp Business API: :"),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "Select  Whatsapp Business API" },
              model: {
                value: _vm.clone.channel,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "channel", $$v)
                },
                expression: "clone.channel",
              },
            },
            _vm._l(_vm.whatsappBusinessChannels, function (channel) {
              return _c(
                "a-select-option",
                { key: channel._id, attrs: { value: channel._id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(channel.name) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.clone.channel
        ? _c("TemplateMessageSelector", {
            attrs: {
              "channel-id": _vm.clone.channel,
              "field-mode": "",
              "default-fields": _vm.fields,
            },
            model: {
              value: _vm.clone,
              callback: function ($$v) {
                _vm.clone = $$v
              },
              expression: "clone",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }